import ComponentInitializer from '../libs/component-initializer.js';
import ComponentBase from './base/component-base.js';

class FixedCta extends ComponentBase {

  private heroCTA: HTMLElement | null;
  private products: HTMLElement | null;
  private intersectionObserver: IntersectionObserver | null = null;
  private isActive: boolean = false;
  private heroCTAVisible: boolean = false;
  private productsVisible: boolean = false; // productsセクションが見えているか
  private productsPassed: boolean = false; // productsセクションを通過したか（下にスクロール）

  constructor(element: HTMLElement) {
    super(element);
    this.heroCTA = document.querySelector('.js-hero-cta') as HTMLElement;
    // product_statementセクションを探す（複数の可能性があるIDをチェック）
    this.products = document.getElementById('product_statement') || 
                    document.getElementById('products') || 
                    document.querySelector('.c-product-section');
    
    console.log('[FixedCta] Elements found:', {
      heroCTA: !!this.heroCTA,
      products: !!this.products,
      productsId: this.products?.id,
      productsClass: this.products?.className
    });
    
    // heroCTAまたはproductsが存在する場合のみIntersection Observerを設定
    if (this.heroCTA || this.products) {
      this.setupIntersectionObserver();
    }
  }
  
  private setupIntersectionObserver() {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // heroCTAの処理
          if (entry.target === this.heroCTA) {
            this.heroCTAVisible = entry.isIntersecting;
            console.log('[FixedCta] heroCTA visible:', this.heroCTAVisible);
          }
          
          // productsの処理
          if (entry.target === this.products) {
            console.log('[FixedCta] products IntersectionObserver triggered:', {
              target: entry.target,
              isIntersecting: entry.isIntersecting,
              intersectionRatio: entry.intersectionRatio,
              boundingClientRect: {
                top: entry.boundingClientRect.top,
                bottom: entry.boundingClientRect.bottom,
                height: entry.boundingClientRect.height
              },
              rootBounds: entry.rootBounds
            });
            
            this.productsVisible = entry.isIntersecting;
            
            // productsを通過したかの判定（画面より上に行った = 下にスクロールした）
            if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
              this.productsPassed = true;
              console.log('[FixedCta] products PASSED (scrolled below)');
            } else if (!entry.isIntersecting && entry.boundingClientRect.top > window.innerHeight) {
              // productsがまだ下にある場合
              this.productsPassed = false;
              console.log('[FixedCta] products NOT YET REACHED (still below)');
            } else if (entry.isIntersecting) {
              // productsが見えている場合、passedフラグをリセット
              this.productsPassed = false;
              console.log('[FixedCta] products VISIBLE');
            }
            
            console.log('[FixedCta] products final state:', {
              visible: this.productsVisible,
              passed: this.productsPassed
            });
          }
        });
        
        // 表示状態を更新
        this.updateVisibility();
      },
      {
        root: null, // ビューポートを基準
        rootMargin: '0px',
        threshold: [0, 0.01, 0.1] // 複数のthresholdで細かく検知
      }
    );
    
    if (this.heroCTA) {
      console.log('[FixedCta] Observing heroCTA');
      this.intersectionObserver.observe(this.heroCTA);
    }
    
    if (this.products) {
      console.log('[FixedCta] Observing products element:', this.products);
      this.intersectionObserver.observe(this.products);
    } else {
      console.warn('[FixedCta] products element not found!');
    }
  }
  
  private updateVisibility() {
    // 条件:
    // 1. heroCTAが見えている → is-activeを削除
    // 2. productsが見えている、または通過した → is-activeを削除
    // 3. それ以外（heroCTAが見えず、かつproductsより上部にいる） → is-activeを付与
    
    console.log('[FixedCta] updateVisibility:', {
      heroCTAVisible: this.heroCTAVisible,
      productsVisible: this.productsVisible,
      productsPassed: this.productsPassed,
      currentIsActive: this.isActive
    });
    
    // heroCTAが見えている、またはproductsが見えている、またはproductsを通過した場合
    if (this.heroCTAVisible || this.productsVisible || this.productsPassed) {
      console.log('[FixedCta] Should DEACTIVATE');
      this.deactivate();
    } else {
      // heroCTAが見えず、かつproductsより上部にいる場合のみアクティブ
      console.log('[FixedCta] Should ACTIVATE');
      this.activate();
    }
  }
  
  private activate() {
    if (this.isActive) {
      console.log('[FixedCta] Already active, skipping');
      return;
    }
    this.isActive = true;
    this.element.classList.add('is-active');
    console.log('[FixedCta] ACTIVATED - class added to element:', this.element);
  }
  
  private deactivate() {
    if (!this.isActive) {
      console.log('[FixedCta] Already inactive, skipping');
      return;
    }
    this.isActive = false;
    this.element.classList.remove('is-active');
    console.log('[FixedCta] DEACTIVATED - class removed from element:', this.element);
  }
}

ComponentInitializer.initializeComponent('.js-fixed-cta', FixedCta);